// extracted by mini-css-extract-plugin
export default {"wrapper":"F4-z","play":"G4-z"};